<template>
  <div class="ui large modal">
    <div class="ui inverted dimmer" v-bind:class="{ active: processing }">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="green play icon"></i>
      {{ $t("start process") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/start_process.png" />
      </div>
      <div class="description">
        <generic-container
          :title="$t('processes')"
          icon="settings"
          ref="process_container"
        >
          <div class="ui list">
            <div
              class="item"
              v-for="(partition, index) in partitions"
              :key="index"
              @click="toggle"
            >
              <i class="layer group icon"></i>
              <div class="content">
                <div class="header">{{ partition.name }}</div>
                <div class="list" v-if="partition.ngn_deployments.length">
                  <div
                    class="item"
                    v-for="(deployment, idx) in partition.ngn_deployments"
                    :key="idx"
                  >
                    <i class="settings icon"></i>
                    <div class="content">
                      <div class="header">{{ deployment.name }}</div>
                      <div class="list">
                        <div
                          class="item"
                          v-for="(process, ix) in deployment.ngn_processes"
                          :key="ix"
                        >
                          <i class="setting group icon"></i>
                          <div class="content">
                            <div
                              class="header"
                              @click="select_process(process)"
                            >
                              <span class="ui blue text">{{
                                process.name
                              }}</span>
                              <small> [{{ deployment.version }}]</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </generic-container>
        <generic-container
          :title="title"
          icon="eye"
          :wide="true"
          ref="task_container"
        >
          <div class="ui form" id="start_instance_form"></div>
        </generic-container>
      </div>
    </div>
    <ngine-workspace-start-modal-starting-point-selection
      ref="starting_point_modal"
      @start_event_selected="start_event_selected"
    />
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import Vue from "vue";
import { clone } from "lodash";
import NgineWorkspaceStartModalStartingPointSelection from "./NgineWorkspaceStartModalStartingPointSelection.vue";

export default {
  components: {
    GenericContainer,
    NgineWorkspaceStartModalStartingPointSelection,
  },
  computed: {
    title() {
      if (this.selected_process) return this.selected_process.name;
      else return this.$t("task");
    },
  },
  data() {
    return {
      processing: false,
      partitions: [],
      user_task_vue: undefined,
      modal: undefined,
      selected_process: undefined,
      // task_html: ""
    };
  },
  methods: {
    select_process(process) {
      let vm = this;
      vm.$refs.task_container.set_loading(true);
      vm.$refs.process_container.toggle();
      let trgt = window.jQuery(vm.$el).find("#start_instance_form");
      trgt.empty();

      local_api(vm, "post", "/ngine_workspace/process/do-get", {
        i: process.uuid,
      })
        .then((_proc) => {
          vm.selected_process = process;
          let StartEvents = _proc.setup.setup.definitions
            .filter((d) => d.$type == "bpmn:StartEvent" && !d.eventDefinitions)
            .map((s) => {
              let humanTask = _proc.ngn_deployment.setup.human_tasks.find(
                (n) => {
                  if (n) return n.uuid == s.ngine_configuration.human_task;
                },
              );
              s.human_task = humanTask;
              return s;
            });

          if (StartEvents.length == 0) {
            error_toast(vm.$t("no start event found"));
            vm.$refs.task_container.set_loading(false);
            vm.$refs.process_container.toggle();
          } else if (StartEvents.length == 1) {
            let start_event = StartEvents[0];

            vm.start_from_event(start_event, _proc, trgt);
          } else {
            vm.$refs.starting_point_modal.show_modal({
              start_events: StartEvents,
              process: _proc,
              target: trgt,
            });
            // console.log("TODO", StartEvents);
            // error_toast(vm.$t("more than one starting point"));
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    toggle($event) {
      let target = window.jQuery($event.srcElement).parent().find(".list");
      target.slideToggle("fast");
    },
    start_event_selected(opts) {
      // console.log("here should start event", opts);
      this.start_from_event(opts.start_event, opts.process, opts.target);
    },
    start_from_event(start_event, _proc, trgt) {
      let vm = this;
      let P = {};
      let V = {};

      let variables =
        _proc.ngn_deployment.setup.variables.filter(
          (n) => n.environment == _proc.ngn_deployment.environment,
        ) || [];
      variables.map((v) => {
        V[v.name] = v.value;
      });

      start_event.human_task.args.map((arg) => {
        let value = arg.type
          ? JSON.parse(
              _proc.ngn_deployment.setup.business_objects.find(
                (n) => n.uuid == arg.type,
              ).structure,
            )
          : "";
        P[arg.name] = value;
      });

      let html = `<div class="ui basic icon labeled button"
                    v-for="(outcome, index) in outcomes"
                    :key="index"
                    style="margin-bottom: 20px"
                    @click="submit_data(outcome)"
                  >
                    <i :class="outcome.icon + ' icon'"></i> {{ outcome.name }}
                  </div>${start_event.human_task.html}<div class="ui error message" />`;
      // vm.task_html = html;

      trgt.html(html);

      var mixin = {};
      var fields = {};
      // var validate_on = [];
      try {
        // eslint-disable-next-line no-unused-vars
        var moment = require("moment");
        start_event.human_task.modifiers
          .filter((m) => m.type == "js")
          .map((m) => {
            eval(m.code);
          });
        start_event.human_task.modifiers
          .filter((m) => m.type == "css")
          .map((m) => {
            var style = document.createElement("style");
            style.type = "text/css";
            style.innerHTML = m.code;
            document.getElementsByTagName("head")[0].appendChild(style);
          });
      } catch (error) {
        error_toast(error);
      }

      setTimeout(() => {
        try {
          if (start_event.human_task.mixin)
            eval(`mixin = ${start_event.human_task.mixin}`);
          vm.user_task_vue = new Vue({
            el: "#start_instance_form",
            data: function () {
              return {
                V: V,
                outcomes: start_event.human_task.outcomes,
                form: undefined,
              };
            },
            filters: filters,
            mixins: [mixin],
            methods: {
              submit_data(outcome) {
                let vm_ = this;
                if (outcome.validate) {
                  if (start_event.human_task.validation)
                    eval(`fields = ${start_event.human_task.validation}`);
                  vm_.form
                    .form({
                      fields: fields,
                      onSuccess() {
                        vm_.do_submit(outcome);
                      },
                    })
                    .form("validate form");
                } else {
                  vm_.do_submit(outcome);
                }
                // if (validate_on.includes(outcome.name)) {
                // } else vm_.do_submit(outcome);
              },
              do_submit(outcome) {
                let vm_ = this;
                vm.$refs.task_container.set_loading(true);

                let data = clone(vm_.$data);
                delete data.V;
                delete data.outcomes;
                delete data.form;

                local_api(vm_, "post", "/ngine_workspace/process/do-start", {
                  e: start_event.id,
                  i: _proc.uuid,
                  l: data,
                  o: outcome.name,
                })
                  .then((instance_id) => {
                    vm.$emit("succedded", instance_id);
                    vm.modal.modal("hide");
                  })
                  .catch((err) => {
                    error_toast(err);
                  });
              },
            },
            mounted() {
              let vm_ = this;
              vm.$refs.task_container.set_loading(false);

              vm_.form = window.jQuery(vm_.$el).form();
            },
          });
        } catch (error) {
          console.error(error);
        }
      }, 200);
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/ngine_workspace/process/do-get-list")
      .then((partitions) => {
        vm.partitions = partitions;
      })
      .catch((err) => {
        error_toast(err);
      });

    vm.modal = window
      .jQuery(vm.$el)
      .modal({
        onShow() {},
        onVisible() {},
        onHidden() {
          vm.$emit("destroy");
          vm.$destroy();
        },
      })
      .modal("show");
  },
  watch: {},
  updated: function () {},
};
</script>
